module.exports = __webpack_public_path__ + "static/media/path01.3ba3ae81.png";